import React, { useEffect, useMemo } from "react";
import "../MyProfile/myProfile.css";
// import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { useState } from "react";
import EditMyProfile from "./EditMyProfile";
import EiditSuccesfully from "./EiditSuccesfully";
import { IP } from "../internalServer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Grid,
  Box,
  Chip,
  IconButton,
  Divider,
  Paper,
  Stack,
} from "@mui/material";
import {
  Close as CloseIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Home as HomeIcon,
  Badge as BadgeIcon,
  CalendarMonth as CalendarIcon,
  Cake as CakeIcon,
  Person as PersonIcon,
  School as SchoolIcon,
} from "@mui/icons-material";

export default function MyProfile({
  setProfile,
  profile,
  userInfo,
  subjectTeacherArray,
  coodinatorArray,
  classTeacherArray,
  subjTeacher,
  cordinator,
  classTeacher,
  classTeacherWithSubjects,
}) {
  const [click, setClick] = useState();
  console.log(classTeacherArray, "classTeacherArray");
  let name = JSON.parse(localStorage.getItem("UserName"));
  let ContactNo = JSON.parse(localStorage.getItem("Mobile_no"));
  let SchoolId = JSON.parse(localStorage.getItem("School_id"));
  let Email = JSON.parse(localStorage.getItem("Email"));

  let emergencyContactNo = JSON.parse(
    localStorage.getItem("emergency_contact_number")
  );
  let teacherAddress = JSON.parse(localStorage.getItem("address"));
  console.log("teacherAddress", teacherAddress);

  let gender = JSON.parse(localStorage.getItem("gender"));
  //let DOB = JSON.parse(localStorage.getItem("date_of_birth"));
  let DOB = userInfo?.date_of_birth;
  //Handling date of birth format
  let role_info = JSON.parse(localStorage.getItem("Role_Information"));
  let dobchng = DOB?.replace(/T/g, "-");
  let dobarr = dobchng?.split("-", 3);

  let DOJ = userInfo?.date_of_joining;
  let dojchange = DOJ?.replace(/T/g, "-");
  let dojarr = dojchange?.split("-", 3);

  // const classTeacher = () => {
  //   // jsonRole_CTinformation.forEach(function (item) {
  //   //   if (item.is_class_teacher === true) {
  //   //     substr = [];
  //   //     let std = item.standard_id.name;
  //   //     let sec = item.section_id.name;
  //   //     item.subjects_id.forEach(function (obj) {
  //   //       let sub = obj.name;
  //   //       let str = "".concat(" ", std, "-", sec, "_", sub);
  //   //       substr.push(str);
  //   //       // console.log(str);
  //   //     });
  //   //     //console.log("hello",substr);
  //   //     // setClassTeacherOf(substr);
  //   //   }
  //   // });
  //   jsonRole_CTinformation?.forEach((item) => {
  //     if (item.is_class_teacher === true) {
  //       const std = item.standard_id?.name;
  //       const sec = item.section_id?.name;
  //       if (std && sec) {
  //         classTeacherArray.push(`${std}-${sec}`)
  //       }
  //     }
  //   });
  // };
  // const cordinator = () => {
  //   coodinatorArray = [];
  //   jsonRole_Coinformation?.forEach(function (item) {
  //     if (item.is_class_co_ordinator === true) {
  //       let std1 = item.standard_id?.name;
  //       let sec1 = item.section_id?.name;
  //       let str = "".concat(" ", std1, "-", sec1);
  //       coodinatorArray.push(str);
  //     }
  //   });
  // };

  // const subjTeacher = () => {
  //   subjectTeacherArray = [];
  //   jsonRole_Geinformation?.forEach((item) => {
  //     let std = item.standard_id?.name;
  //     let sec = item.section_id?.name;
  //     item?.subjects_id?.forEach(function (obj) {
  //       let sub = obj?.name;
  //       let str = "".concat(" ", std, "-", sec, "_", sub);
  //       subjectTeacherArray.push(str);
  //       // console.log(str);
  //     });
  //   });
  //   // jsonRole_Coinformation?.forEach((item) => {
  //   //   let std = item.standard_id?.name;
  //   //   let sec = item.section_id?.name;
  //   //   item?.subjects_id?.forEach(function (obj) {
  //   //     let sub = obj?.name;
  //   //     let str = "".concat(" ", std, "-", sec, "_", sub);
  //   //     // subtec.push(str);
  //   //     // console.log(str);
  //   //   });
  //   // });
  //   // jsonRole_CTinformation?.forEach((item) => {
  //   //   let std = item.standard_id.name;
  //   //   let sec = item.section_id.name;
  //   //   item?.subjects_id?.forEach(function (obj) {
  //   //     let sub = obj?.name;
  //   //     let str = "".concat(" ", std, "-", sec, "_", sub);
  //   //     // subtec.push(str);
  //   //     // console.log(str);
  //   //   });
  //   // });
  // };
  // classTeacher();
  // cordinator();
  // subjTeacher();
  useEffect(() => {
    subjTeacher();
    cordinator();
    classTeacher();
  }, []);

  const mergedSubjectTeacherList = useMemo(() => {
    const normalSubjects = subjectTeacherArray || [];

    const classTeacherSubjects =
      classTeacherWithSubjects?.map((item) => {
        const subjectsString = item.subjects?.join(", ");
        return `${item.classSection} (${subjectsString})`;
      }) || [];

    return [...normalSubjects, ...classTeacherSubjects];
  }, [subjectTeacherArray, classTeacherWithSubjects]);

  const InfoItem = ({ icon, label, value }) => (
    <Box
      sx={{
        mb: 2,
        p: 1,
        borderRadius: 1,
        bgcolor: "#f5f5f5",
        boxShadow: 1,
        ":hover": {
          cursor: "pointer",
          border: " 1px solid orange",
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
        {icon}
        <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
          {label}
        </Typography>
      </Box>
      <Typography variant="body1" sx={{ ml: 4, fontWeight: 500 }}>
        {value || "--"}
      </Typography>
    </Box>
  );

  return (
    <>
      <div id="profile_all_Container">
        <Card
          className="orange-scrollBar"
          sx={{ height: "100vh - 105px", overflowY: "scroll" }}
        >
          <CardContent>
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
              }}
            >
              <Typography
                variant="h4"
                component="h2"
                sx={{ fontWeight: 600, color: "primary.main" }}
              >
                My Profile
              </Typography>
              <IconButton
                onClick={() => setProfile(false)}
                sx={{
                  "&:hover": { backgroundColor: "error.light", color: "white" },
                }}
              >
                <CloseIcon fontSize="large" />
              </IconButton>
            </Box>

            {/* Profile Section */}
            <Paper elevation={1} sx={{ p: 3, mb: 3, bgcolor: "grey.50" }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <img
                  src={
                    userInfo?.profile_picture
                      ? IP + userInfo?.profile_picture.replace(/^\./, "")
                      : userInfo?.gender === "M"
                        ? "/images/Teacher_Male.jpg"
                        : userInfo?.gender === "F"
                          ? "/images/Teacher_Female.png"
                          : "/images/default-profile.png"
                  }
                  alt={name}
                  style={{
                    width: 80, // Avatar width
                    height: 80, // Avatar height
                    borderRadius: "50%", // circle
                    objectFit: "cover", // crop like Avatar
                    marginRight: "12px", // Avatar ka mr:3 (≈12px)
                    boxShadow: "0px 2px 6px rgba(0,0,0,0.2)", // same shadow
                  }}
                  onError={(e) => {
                    if (userInfo?.gender === "M") {
                      e.currentTarget.src = "/images/Teacher_Male.jpg";
                    } else if (userInfo?.gender === "F") {
                      e.currentTarget.src = "/images/Teacher_Female.png";
                    } else {
                      e.currentTarget.src = "/images/default-profile.png";
                    }
                  }}
                />

                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, color: "text.primary" }}
                >
                  {name}
                </Typography>
              </Box>

              <Divider sx={{ my: 3 }} />

              {/* Personal Information Grid */}

              <Grid container spacing={2}>
                {[
                  {
                    icon: <PersonIcon color="action" fontSize="small" />,
                    label: "Gender",
                    value:
                      gender === "M"
                        ? "Male"
                        : gender === "F"
                          ? "Female"
                          : "Others",
                  },
                  {
                    icon: <EmailIcon color="action" fontSize="small" />,
                    label: "Email ID",
                    value: Email,
                  },
                  {
                    icon: <BadgeIcon color="action" fontSize="small" />,
                    label: "Employee ID",
                    value: userInfo?.code,
                  },
                  {
                    icon: <CalendarIcon color="action" fontSize="small" />,
                    label: "Date of Joining",
                    value:
                      dojarr && dojarr?.length > 0
                        ? `${dojarr[2]}-${dojarr[1]}-${dojarr[0]}`
                        : "--",
                  },
                  {
                    icon: <CakeIcon color="action" fontSize="small" />,
                    label: "Date of Birth",
                    value:
                      dobarr && dobarr?.length > 0
                        ? `${dobarr[2]}-${dobarr[1]}-${dobarr[0]}`
                        : "--",
                  },
                  {
                    icon: <PhoneIcon color="action" fontSize="small" />,
                    label: "Contact Number",
                    value: ContactNo,
                  },
                  {
                    icon: <PhoneIcon color="action" fontSize="small" />,
                    label: "Emergency Contact",
                    value: emergencyContactNo,
                  },
                  {
                    icon: <HomeIcon color="action" fontSize="small" />,
                    label: "Address",
                    value: `${teacherAddress?.line1 || "-"} ${teacherAddress?.building_number || "-"} ${teacherAddress.city || "-"} ${teacherAddress?.state || "-"} ${teacherAddress?.country || "-"}`,
                  },
                ].map((item, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <InfoItem
                      icon={item.icon}
                      label={item.label}
                      value={item.value}
                    />
                  </Grid>
                ))}
              </Grid>
            </Paper>

            {/* Class Handling Section */}
            <Paper elevation={1} sx={{ p: 3, bgcolor: "primary.50" }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <SchoolIcon color="primary" sx={{ mr: 1 }} />
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, color: "primary.main" }}
                >
                  Class Handling
                </Typography>
              </Box>

              <Grid container spacing={2}>
                {/* Class Teacher Box */}
                <Grid item xs={4}>
                  <Box
                    sx={{
                      border: "1px solid #ddd",
                      borderRadius: 2,
                      p: 2,
                      bgcolor: "#fafafa",
                      textAlign: "center",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: 3,
                        bgcolor: "#f5f5f5",
                        borderColor: "primary.main",
                      },
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      sx={{ fontWeight: 600, mb: 1 }}
                    >
                      As Class Teacher
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 1,
                        justifyContent: "center",
                      }}
                    >
                      {classTeacherArray?.length > 0 ? (
                        classTeacherArray.map((item, index) => (
                          <Chip
                            key={index}
                            label={item}
                            color="primary"
                            variant="outlined"
                          />
                        ))
                      ) : (
                        <Typography variant="body2" color="text.disabled">
                          --
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Grid>

                {/* Coordinator Box */}
                <Grid item xs={4}>
                  <Box
                    sx={{
                      border: "1px solid #ddd",
                      borderRadius: 2,
                      p: 2,
                      bgcolor: "#fafafa",
                      textAlign: "center",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: 3,
                        bgcolor: "#f5f5f5",
                        borderColor: "secondary.main",
                      },
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      sx={{ fontWeight: 600, mb: 1 }}
                    >
                      As Coordinator
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 1,
                        justifyContent: "center",
                      }}
                    >
                      {coodinatorArray?.length > 0 ? (
                        coodinatorArray.map((item, index) => (
                          <Chip
                            key={index}
                            label={item}
                            color="secondary"
                            variant="outlined"
                          />
                        ))
                      ) : (
                        <Typography variant="body2" color="text.disabled">
                          --
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Grid>

                {/* Subject Teacher Box */}
                <Grid item xs={4}>
                  <Box
                    sx={{
                      border: "1px solid #ddd",
                      borderRadius: 2,
                      p: 2,
                      bgcolor: "#fafafa",
                      textAlign: "center",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: 3,
                        bgcolor: "#f5f5f5",
                        borderColor: "success.main",
                      },
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      sx={{ fontWeight: 600, mb: 1 }}
                    >
                      As Subject Teacher
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 1,
                        justifyContent: "center",
                      }}
                    >
                      {mergedSubjectTeacherList?.length > 0 ? (
                        mergedSubjectTeacherList.map((item, index) => (
                          <Chip
                            key={index}
                            label={item}
                            color="success"
                            variant="outlined"
                          />
                        ))
                      ) : (
                        <Typography variant="body2" color="text.disabled">
                          --
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Paper>

            {click && (
              <EditMyProfile
                setClick={setClick}
                setProfile={setProfile}
                userInfo={userInfo}
              />
            )}
          </CardContent>
        </Card>
      </div>
    </>
  );
}
